
var slide_ingredient_mo = new Swiper(".ingredient_mo", {
    loop: true,
    slidesPerView: 1,
    navigation: {
        nextEl: '.ingredient_mo .swiper-button-next',
        prevEl: '.ingredient_mo .swiper-button-prev',
    },
    pagination: {
        el: ".ingredient_mo .swiper-pagination",
    },
});

const ingredient_leng = $('.ingredient_mo .swiper-slide:not(.swiper-slide-duplicate)').length;
$('.ingredient_hover').attr('data-length',ingredient_leng);

for(var i = 1; i <= ingredient_leng; i++){
    let ing_txt = $('.ingredient_mo .swiper-slide:not(.swiper-slide-duplicate)').eq(i-1).find('.ingredient_text').html()
    $('.ingredient_hover').append('<div class="ingredient_hover_wrap" rel="'+i+'"><span class="hover_circle"></span><div class="ingredient_bubble">'+ing_txt+'</div></div>');
}

$('.ingredient_hover_wrap').mouseenter(function(){
    $(this).find('.ingredient_bubble').stop().fadeIn();
})
$('.ingredient_hover_wrap').mouseleave(function(){
    $(this).find('.ingredient_bubble').stop().fadeOut();
})
